import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@ryde/layout";

import { ProfilePageMain } from "./search";

export const ProfilePage: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader mainTitle={t(`general.PROFILE`)} />
      <ProfilePageMain />
    </>
  );
};
